import { NgxLoggerLevel } from "ngx-logger";

export const environment = {
  production: true,
  version:"6",
  amplitudeEnabled: false,
  amplitudeApiKey:"ef5eb76408d61f9133b62ec0f063dfb2",
  amplitudeServerUrl:"https://api.eu.amplitude.com/2/httpapi",
  NgxLoggerSettings:{
    enableSourceMaps :false,
    level: NgxLoggerLevel.ERROR
  }
};
